var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"http-img",attrs:{"src":_vm.internalSrc,"draggable":"false"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }